import { gql } from '@apollo/client';
const REMOVE_PRODUCT_EVENT = gql `
  mutation RemoveProductEvent($productEventId: ID!) {
    removeProductEvent(productEventId: $productEventId) {
      removed
    }
  }
`;
export default REMOVE_PRODUCT_EVENT;
